export const USER = "user";
export const SIGN_UP_OPTIONS = "sign-up-options";